export { default } from "bullitttime-embermodelsevent/serializers/application";
